import * as yup from 'yup';
import { eEscrowWireDisbursementCategories } from './enums/eEscrowWireDisbursementCategories';
import { getWireRoutingByRoutingNumber } from '../../../../../../API/order/escrow/EscrowAPI';

export const createWireFromACHSchema = yup.object({
  beneficiary_name: yup.string().nullable().required().label('Beneficiary Name'),
  routing_number: yup
    .string()
    .nullable()
    .required()
    .length(9)
    // eslint-disable-next-line no-template-curly-in-string
    .matches(/^\d{9}$/, { excludeEmptyString: true, message: '${path} must be digits only' })
    // eslint-disable-next-line no-template-curly-in-string
    .test('is-wire-routing-number', '${path} must be valid wire routing number', async (value) => {
      if (value && value.length === 9) {
        try {
          const result = await getWireRoutingByRoutingNumber(value);
          return !!result;
        } catch (e: any) {
          return false;
        }
      } else {
        return false;
      }
    })
    .label('Routing Number'),
  account_number: yup.string().nullable().required().label('Account Number'),
  memo: yup.string().nullable().required().label('Memo'),
  amount: yup.string().nullable().required().label('Amount'),
  category: yup.mixed<eEscrowWireDisbursementCategories>().nullable().required().label('Category'),
});
